export default class {
  constructor(selector) {
    this.button = document.querySelector(selector);
    this.menu = document.querySelector(`#${this.button.getAttribute('aria-controls')}`);
    this.closeButton = this.menu.querySelector('button[aria-label="Close menu"]');
    this.button.addEventListener('click', this.expand.bind(this));
    this.closeButton.addEventListener('click', this.collapse.bind(this));
  }

  button;

  menu;

  closeButton;

  expand() {
    document.documentElement.classList.add('popup');
    this.menu.removeAttribute('hidden');
    this.button.setAttribute('aria-expanded', 'true');
  }

  collapse() {
    document.documentElement.classList.remove('popup');
    this.menu.setAttribute('hidden', 'hidden');
    this.button.setAttribute('aria-expanded', 'false');
  }
}
